let getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

const $header = $('header.masthead'),
    $tabs = $('.section__tabs'),
    classSticky = 'section__tabs--sticky';

$('.tabs').each(function () {
    $('.tab, .mobile-tab', this).on('click', function () {
        let tabID = $(this).attr('data-tab-id');

        if (typeof tabID !== 'undefined') {
            $('.tab[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.tab').attr('data-state', '');
            $('.mobile-tab[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.mobile-tab').attr('data-state', '');
            $('.tab-panel[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.tab-panel').attr('data-state', '');

            // refresh slick sliders after change
            setTimeout(function () {
                $('.tab-panel[data-tab-id="'+tabID+'"]').find('.slick-slider').slick('refresh');
            }, 10);

            // add url parameter for active tab
            window.history.replaceState(null, null, '?tab=' + tabID);

            // if on mobile, scroll to top of tab-panel (content)
            if (viewport().width < 768) {
                let scrollTo = $('.tab-panel[data-tab-id="'+tabID+'"]').offset().top;

                scrollTo -= $tabs.find('.tabs__list .container').outerHeight(); // add offset for sticky tabs

                if (Math.round(scrollTo) !== $('html, body').scrollTop()) {
                    $('html, body').stop().animate({
                        scrollTop: scrollTo
                    }, 500).promise().done(function () {
                        setTimeout(function () {
                            $header.removeClass('masthead--visible');
                        }, 10);
                    });
                }
            }
        }
    });

    // init: open active tab based on url parameter
    if (getUrlParameter('tab')) {
        let tabID = getUrlParameter('tab');

        $('.tab[data-tab-id="'+tabID+'"]').trigger('click');
    }

    // init: check for active tab or make one
    if ($('.tab[data-state="active"]', this).length < 1) {
        $('.tab', this).first().attr('data-state', 'active').trigger('click');
    }
});

if ($tabs.length > 0) {
    let scrollThreshold = $tabs.offset().top,
        vpWidth = viewport().width;

    $(window).on('resize', function () {
        scrollThreshold = $tabs.offset().top;
        vpWidth = viewport().width;
    });

    window.addEventListener('scroll', function () {
        let scroll = window.scrollY;

        if (scroll > scrollThreshold && vpWidth < 768) {
            $tabs.css('height', $tabs.outerHeight());
            $tabs.addClass(classSticky);
        } else {
            $tabs.removeClass(classSticky);
            $tabs.css('height', '');
        }
    });
}
